import React, { useContext, useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Update_Work_From } from "./../components/Detail_Work_From/form";
import { AppContext } from "./../contexts/appContext";
import { workAPI } from "./../services/WorkService";
import { Container, Typography, Box } from "@material-ui/core";
import moment from "moment";
import Swal from "sweetalert2";

const Detail_Work = () => {
  let history = useHistory();
  const { _id } = useParams();
  const { user, socket, notifications, setNotifications } =
    useContext(AppContext);
  const token = localStorage.getItem("Token");
  const [data, setData] = useState(null);
  const [comment, setComment] = useState([]);
  const [chatUser, setChatUesr] = useState("");
  const [open, setOpen] = useState(true);
  const [newZ, setNew] = useState(0);

  useEffect(() => {
    if (_id && user) {
      workAPI
        .getWorkByID(token, _id)
        .then((res) => {
          if (res.status == 200) {
            setData(res.message);
            setComment(res.message.comment);
            document.title = `Com7 Merchandise - ${res.message.title}`;
            if (
              notifications.filter(
                (res) => res.push_to.includes(_id) && !res.is_read
              ).length >= 1
            ) {
              let notificationsFilter = [...notifications];
              notificationsFilter = notificationsFilter.map((res) => {
                if (res.push_to.includes(_id)) {
                  res.is_read = true;
                }
                return res;
              });
              setNotifications(notificationsFilter);
            }
          } else {
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">คุณไม่ได้เป็นคนสร้างงานนี้</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 5000,
            }).then(() => {
              history.push("/");
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 5000,
          }).then(() => {
            history.push("/");
          });
        });
    }
    return () => {
      setData([]);
    };
  }, [user, _id]);
  useEffect(() => {
    if (user) {
      let fullname = "";
      fullname = user.fullname.split(" ");
      fullname = fullname[0];
      fullname = fullname.replace("นาย", "");
      fullname = fullname.replace("นางสาว", "");
      fullname = fullname.replace("นาง", "");
      socket.emit("SendMessageByID", {
        _id,
        message_obj: {
          text: " ",
          time: moment().toString(),
          user: user.username,
          image: null,
          name: fullname,
        },
      });
      socket.on("SendMessageByID", ({ status, message }) => {
        if (status == 200) {
          setComment((old) => [...old, message]);
        }
      });
    }
  }, [user]);

  useEffect(() => {
    if (open) {
      if (newZ != 0) {
        setNew(0);
      }
    }
  }, [open]);

  useEffect(() => {
    if (Array.isArray(comment) && comment.length >= 1) {
      let lastindex = comment.length - 1;
      if (comment[lastindex].user != user.username && !open) {
        setNew((old) => old + 1);
      }
      let message = "";
      let userComment = comment.reduce((prev, curr) => {
        let findUserDuplicate = prev.find((res) => res == curr.name);
        if (!findUserDuplicate && curr.name) {
          prev.push(curr.name);
        }
        return prev;
      }, []);

      userComment.map((res) => {
        message = message + (message != "" ? "," : "") + res;
      });
      setChatUesr(message);
    }
  }, [comment]);

  return (
    data && (
      <React.Fragment>
        <Container
          style={{
            paddingLeft: "0",
            paddingRight: "0",
            paddingTop: user.role == "Retail" ? "9vh" : "4.5vh",
          }}
        >
          <Typography
            component="div"
            style={{ backgroundColor: "white", borderRadius: "10px" }}
          >
            <Container
              style={{ marginTop: "10px", height: "10%", paddingTop: "20px" }}
            >
              <Typography variant="h4" style={{ fontWeight: "bold" }}>
                {" "}
                Update Work
              </Typography>
            </Container>
            <Container
              style={{
                display: "flex",
                padding: "0px 25px",
                height: "90%",
                marginTop: "1%",
              }}
            >
              <Box color="primary.main">
                {data && (
                  <Update_Work_From
                    data={data}
                    setData={setData}
                    _id={_id}
                    comment={comment}
                    newZ={newZ}
                    open={open}
                    setOpen={setOpen}
                    chatUser={chatUser}
                  />
                )}
              </Box>
            </Container>
          </Typography>
        </Container>
      </React.Fragment>
    )
  );
};

export default Detail_Work;
